import type { CoreApiClient } from "../client";
import type {
  CreateGatewayRequestBody,
  Gateway,
  ReconcileGatewaysRequestBody,
  UpdateGatewaysRequestBody,
} from "../types/gateway.type";

export const createGatewayMutations = (api: CoreApiClient) => {
  const { request } = api;

  /** Create a single gateway. The add dialog fans this out over its staged boxes. */
  const create = async (buildingId: string, body: CreateGatewayRequestBody): Promise<Gateway> => {
    const { data } = await request("post", "/buildings/{buildingId}/gateways", {
      params: { path: { buildingId } },
      body,
    });
    return data;
  };

  /** Atomically apply a pre-install change-set (`{ create, update, deleteGateway }`) in one transaction. */
  const reconcile = async (buildingId: string, body: ReconcileGatewaysRequestBody): Promise<void> => {
    await request("patch", "/buildings/{buildingId}/gateways/preinstall", {
      params: { path: { buildingId } },
      body,
    });
  };

  const update = async (buildingId: string, body: UpdateGatewaysRequestBody): Promise<void> => {
    await request("patch", "/buildings/{buildingId}/gateways", {
      params: { path: { buildingId } },
      body,
    });
  };

  const deleteGateway = async (buildingId: string, gatewayId: string): Promise<void> => {
    await request("delete", "/buildings/{buildingId}/gateways/{gatewayId}", {
      params: { path: { buildingId, gatewayId } },
    });
  };

  return {
    create,
    reconcile,
    update,
    delete: deleteGateway,
  };
};
